import * as a from "redux/actions/action_types";

const invoice = (state, action) => {
    if (state === undefined) {
      state = null;
    }
    switch (action.type) {
      case a.INVOICE_DATA:
        return action.payload;
  
      default:
        return state;
    }
  };
  
  export default invoice;